/* function expiviScreenshot() {
  window.expivi.getScreenshot(1024, 1024).then(function(aScreenshotBase64) {

    // Open in new tab.
    const image = new Image();
    image.src = aScreenshotBase64;

    const w = window.open('_screenshot');
    window.setTimeout(function() {
        w.document.write(image.outerHTML);
    }, 0);
} );
} */

function expiviScreenshot() {
    window.expivi.getScreenshot(1024, 1024, 'image/png').then(function(aScreenshotBase64) {
        // Create an invisible link
        const link = document.createElement('a');
        link.href = aScreenshotBase64;

        // Set the download attribute with a custom file name
        link.download = 'custom_cosmicears.png';

        // Append the link to the document and click it
        document.body.appendChild(link);
        link.click();

        // Remove the link after clicking
        document.body.removeChild(link);
    });
}




var darkmodeSwitch = false;
function darkmodeSwitcher() {
		darkmodeSwitch = !darkmodeSwitch;
		if (darkmodeSwitch) {
			
			expivi.setProductAttribute(191596,466452)
		}
		else {
			expivi.setProductAttribute(191596,466451)
			
		}
		
	}

